import { render } from "./EnUnit6-2.vue?vue&type=template&id=0cc35a56&scoped=true"
import script from "./EnUnit6-2.vue?vue&type=script&lang=js"
export * from "./EnUnit6-2.vue?vue&type=script&lang=js"

import "../assets/css/en-common.css?vue&type=style&index=0&id=0cc35a56&scoped=true&lang=css"
import "../assets/css/en/Unit6-2.css?vue&type=style&index=1&id=0cc35a56&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc35a56"]])

export default __exports__